import React, { useState } from "react";
import "./modals.scss";
import { useReportBug } from "../../hooks/useReportBug";
function ReportBugModal({ onClose }) {
  const [message, setMessage] = useState("");
  const { reportTheBug } = useReportBug();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!message.trim()) {
      alert("Please describe the issue before submitting.");
      return;
    }

    const bugReportData = {
      message: message,
    };

    try {
      const result = await reportTheBug(bugReportData);
      console.log("Bug report result:", result);

      if (result) {
        alert("Thank you! Your bug report has been submitted.");
        onClose();
      } else {
        alert("Failed to submit the bug report.");
      }
    } catch (err) {
      console.error("Error submitting bug report:", err);
      alert("An error occurred while submitting the bug report.");
    }
  };

  return (
    <div className="report-modal-overlay" onClick={onClose}>
      <div className="report-modal" onClick={(e) => e.stopPropagation()}>
        <h5>Report a Bug</h5>
        <p>Please describe what went wrong:</p>

        <form onSubmit={handleSubmit}>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows="5"
            placeholder="Describe the issue in detail..."
            required
            className="bug-textarea"
          ></textarea>

          <button type="submit" className="report-email-link">
            Send Bug Report
          </button>
        </form>

        <button className="close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

export default ReportBugModal;
